<template>
  <div class="container">
    <!-- 头部 -->
    <div class="header" :class="{ 'scrolled': isScrolled }">
      <!-- 友情链接 -->
      <a href="https://xingwubazi.com" target="_blank" class="friend-link" title="星武装他字">
        <img src="/assistant.png" alt="星武装他字" class="friend-link-img" />
      </a>
      <div class="header-content">
        <div class="app-info">
          <img v-if="headerInfo && headerInfo.isShow && headerInfo.logo && headerInfo.logo.url"
            class="logo" :src="headerInfo.logo.url" alt="logo">
          <span class="title" :style="{'color': headerInfo.nameColor}"> {{headerInfo.name}}</span>
        </div>
        <div class="tabs">
        <div v-if="username" class="profile-menu">
            <button class="profile-trigger" type="button">
              <span class="profile-icon">👤</span>
              <span>{{ displayName }}</span>
            </button>
            <div class="profile-dropdown">
              <button @click="openProfileEditor">个人信息编辑</button>
              <button @click="openContactSection">联系站长</button>
              <button @click="relogin">退出登录</button>
            </div>
          </div>
          <div v-else @click="tologin" class="tab-item login-btn">
            未登录 · 登录
          </div>
        </div>
      </div>
    </div>

    <div v-if="showProfileModal" class="account-modal" @click.self="showProfileModal = false">
      <div class="account-panel">
        <div class="account-panel-header">
          <h3>个人信息编辑</h3>
          <button @click="showProfileModal = false">×</button>
        </div>
        <div class="account-form">
          <label>手机号</label>
          <input :value="profileForm.phone" disabled />
          <label>昵称</label>
          <input v-model="profileForm.name" placeholder="请输入昵称" />
          <label>抖音ID</label>
          <input v-model="profileForm.dyid" placeholder="请输入抖音ID" />
          <label>邀请码</label>
          <input 
            v-model="profileForm.inviteCode" 
            :disabled="profileForm.inviteCode !== ''" 
            :placeholder="profileForm.inviteCode === '' ? '请联系站长领取邀请码' : ''"
            :class="{ 'input-disabled': profileForm.inviteCode !== '' }"
          />
        </div>
        <div class="account-actions">
          <button @click="showProfileModal = false">取消</button>
          <button class="primary" @click="saveProfile">保存</button>
        </div>
      </div>
    </div>

    <!-- 邀请码提示弹窗 -->
    <div v-if="showInviteModal" class="invite-modal-overlay" @click.self="showInviteModal = false">
      <div class="invite-modal">
        <div class="invite-modal-header">
          <h3>⚠️ 请先填写邀请码</h3>
          <button class="close-btn" @click="showInviteModal = false">×</button>
        </div>
        <div class="invite-modal-body">
          <p>您还没有填写邀请码，无法使用此功能。</p>
          <p>请联系站长获取邀请码：</p>
          <div class="contact-info">
            <div class="contact-item">
              <span class="contact-label">📱 抖音：</span>
              <span>{{ appIntroduce.content }}</span>
            </div>
            <div class="qrcode-container">
              <img :src="appIntroduce.showImg" alt="抖音二维码" class="modal-qrcode">
              <p class="qrcode-tip">抖音扫码关注</p>
            </div>
          </div>
          <div class="invite-modal-actions">
            <button class="primary-btn" @click="goToProfile">去填写邀请码</button>
            <button class="secondary-btn" @click="showInviteModal = false">稍后再说</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 滚动 -->
    <!-- 视频轮播区域 - 移到scroll-view外面实现全屏 -->
    <div id="row0" class="carousel-wrapper-full">
      <div class="carousel">
        <div v-for="(posterItem, posterIndex) in posterData" :key="posterIndex" 
          class="carousel-item" :class="{ active: posterIndex === currentIndex }">
          <video v-if="posterItem.isVideo" class="carousel-video" :src="posterItem.videoUrl" autoplay muted loop
            playsinline @loadedmetadata="setBannerPlaybackRate"></video>
          <img v-else-if="posterItem && posterItem.bannerfile && posterItem.bannerfile.url"
            class="carousel-image" :src="posterItem.bannerfile.url" alt="banner">
          <div class="carousel-overlay"></div>
          <div class="carousel-content">
              <img v-if="posterItem.iconUrl" :src="posterItem.iconUrl" class="banner-icon" />
              <img v-if="posterItem.titleImage" :src="posterItem.titleImage" class="banner-title-image" />
              <div v-else class="carousel-text">
                <h2 class="carousel-title" :style="{'color': posterItem.titleColor}">
                  {{posterItem.title}}</h2>
                <p class="carousel-subtitle" :style="{'color': posterItem.subTitleColor}">
                  {{posterItem.subTitle}}</p>
              </div>
              <div v-if="username" class="banner-nav">
                <button type="button" class="banner-nav-item" @click="checktopage()">
                  <i class="fas fa-file-lines banner-nav-icon"></i>
                  <span>取件表制作</span>
                </button>
                <button type="button" class="banner-nav-item" @click="checktoAiColoringList()">
                  <i class="fas fa-palette banner-nav-icon"></i>
                  <span>AI上色任务</span>
                </button>
                <button type="button" class="banner-nav-item" @click="checktoImageGenerator()">
                  <i class="fas fa-image banner-nav-icon"></i>
                  <span>AI生图</span>
                </button>
              </div>
            </div>
        </div>
      </div>
    </div>

    <div class="scroll-view" ref="scrollView">
      <!-- 使用指南 -->
      <div id="row1" class="section">
        <div class="section-header">
          <span class="section-title" :style="{'color': headerInfo.titleColor}">📋 取件表使用指南</span>
          <div class="section-divider"></div>
        </div>
        <div class="ds-steps">
          <div v-for="(step, index) in steps" :key="index" class="ds-step" @mouseover="handleStepHover(index)">
            <div class="ds-step-header">
              <span class="ds-step-badge">{{ index === 0 ? '📄' : index === 1 ? '🤖' : '✅' }} 步骤 {{ index + 1 }}</span>
              <div class="ds-step-decorator"></div>
            </div>
            <img class="ds-step-image" :src="step.image" alt="step"
              :style="{ filter: activeStep === index ? 'drop-shadow(0 4px 12px rgba(0, 120, 255, 0.2))' : '' }">
            <div class="ds-step-content">
              <span class="ds-step-description">{{ step.description }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 使用指南 -->
      <div id="row1" class="section">
        <div class="section-header">
          <span class="section-title" :style="{'color': headerInfo.titleColor}">📋 AI上色任务使用指南</span>
          <div class="section-divider"></div>
        </div>
        <div class="ds-steps">
          <div v-for="(step, index) in colorsteps" :key="index" class="ds-step" @mouseover="handleStepHover(index)">
            <div class="ds-step-header">
              <span class="ds-step-badge">{{ index === 0 ? '📄' : index === 1 ? '🤖' : '✅' }} 步骤 {{ index + 1 }}</span>
              <div class="ds-step-decorator"></div>
            </div>
            <img class="ds-step-image" :src="step.image" alt="step"
              :style="{ filter: activeStep === index ? 'drop-shadow(0 4px 12px rgba(0, 120, 255, 0.2))' : '' }">
            <div class="ds-step-content">
              <span class="ds-step-description">{{ step.description }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- AI生图功能 -->
      <div id="row2" class="section image-generator-section">
        <div class="section-header">
          <span class="section-title" :style="{'color': headerInfo.titleColor}">🎨 AI 生图工具</span>
          <div class="section-divider"></div>
        </div>
        <div class="generator-content">
          <div class="generator-features">
            <div class="feature-card">
              <div class="feature-icon">📷</div>
              <h4>参考图片</h4>
              <p>支持上传单张或多张参考图片，AI将根据参考图进行创作</p>
            </div>
            <div class="feature-card">
              <div class="feature-icon">✍️</div>
              <h4>智能提示词</h4>
              <p>输入详细描述，支持多种风格预设，生成精准匹配的图片</p>
            </div>
            <div class="feature-card">
              <div class="feature-icon">⚙️</div>
              <h4>灵活参数</h4>
              <p>自定义图片比例、生成数量，满足不同场景需求</p>
            </div>
            <div class="feature-card">
              <div class="feature-icon">🔄</div>
              <h4>异步生成</h4>
              <p>后台异步处理，不阻塞操作，随时查看生成进度</p>
            </div>
          </div>
          <div class="generator-action">
            <button class="generator-btn" @click="checktoImageGenerator()">
              <span class="btn-icon">🚀</span>
              <span>立即体验</span>
            </button>
            <p class="generator-tip">登录后即可使用</p>
          </div>
        </div>
      </div>

      <!-- 联系我们 -->
      <div id="row3" class="section contact-section">
        <div class="section-header">
          <span class="section-title" :style="{'color': headerInfo.titleColor}">📞 联系我们</span>
          <div class="section-divider"></div>
        </div>
        <div class="contact-content">
          <span class="contact-slogan">{{ appIntroduce.slogan }}</span>
          <div class="dy-info">
            <span class="dy-name">{{ appIntroduce.content }}</span>
          </div>
          <div class="dy-qrcode">
            <img class="qrcode-image" :src="appIntroduce.showImg" alt="二维码">
          </div>
          <span class="dy-name">打破想象边界，重塑模型未来！~</span>
        </div>
      </div>

      <!-- 项目进展 -->
      <div id="row4" class="section project-section">
        <div class="section-header">
          <span class="section-title" :style="{'color': headerInfo.titleColor}">📅 项目进展</span>
          <div class="section-divider"></div>
        </div>
        <div class="project-timeline">
          <div v-for="(milestone, index) in projectMilestones" :key="index" class="milestone">
            <div class="milestone-content">
              <div class="milestone-date">{{ milestone.date }}</div>
              <h4 class="milestone-title">{{ milestone.title }}</h4>
              <p class="milestone-description">{{ milestone.description }}</p>
            </div>
            <div class="milestone-dot" :class="{'active': milestone.completed}"></div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 页脚 -->
    <div class="footer">
      <p>地球联邦军 © 2023 版权所有</p>
      <p>技术支持：阿纳海姆电子公司 | 粤ICP备2026000017号-1 | 中山祖艺模玩</p>
    </div>
  </div>
</template>

<script>
import { clearAuthSession, showToast, navigateTo, getStorageSync, setStorageSync } from '@/utils/uni-app'
import api from '@/api'

export default {
  name: 'HomePage',
  data() {
    return {
      page: 1,
      subject: "",
      keyword: "",
      total: 1000,
      pageSize: 10,
      array: ["全部", "MG", "MG 1", "RG 1", "RG限定", "PGU", "PG限定"],
      subjectindex: 0,
      currentId: '',
      posterWidth: "180",
      posterHeight: '',
      showMob: false,
      activeIndex: 0,
      offsetTops: [],
      lock: false,
      currentIndex: 0,
      carouselTimer: null,
      headerInfo: {
        "_id": "header",
        "logo": {
          "extname": "23",
          "name": "255",
          "url": "https://testxingguang.oss-cn-hangzhou.aliyuncs.com/paperlist/xianlitilogo.png"
        },
        "name": "彩霞爸爸模型工具",
        "nameColor": "#543",
        "tabbar": ["🏠 首页", "📖 使用指南", "📞 联系站点"],
        "tabColor": "#543",
        "headerBackground": "https://www.mynew-miracle.com/Application/Tpl/App/default/Index/homepage/static/img/03.1bcdb4d.jpg",
        "titleColor": "#00aaff",
        "isShow": true
      },
      // 轮播数据
      posterData: [{
        "title": "",
        "iconUrl": "/bannericon.png",
        "titleImage": "/title.png",
        "subTitle": "",
        "isVideo": true,
        "videoUrl": "https://agamaship.com/agamashipdiv.mp4",
        "open_url": "#",
        "titleColor": "#ffffff",
        "subTitleColor": "#ffffff",
        "bannerBackground": "#000000"
      }],
      // 下载
      downloadInfo: [{
        "open_url": "http://zhushou.360.cn/",
        "name": "MGEX强袭自由",
        "author": "作者",
        "subject": "MG",
        "type": "default",
        "status": "未下载",
        "bannerfile": {
          "url": "https://www.mynew-miracle.com/Application/Tpl/App/default/Index/homepage/static/img/03.1bcdb4d.jpg"
        }
      }],
      // 联系信息
      appIntroduce: {
        "slogan": "💬 打破想象边界，重塑模型未来！",
        "content": "📱 未老年模型玩家彩霞爸爸",
        "showImg": "https://testxingguang.oss-cn-hangzhou.aliyuncs.com/paperlist/dyqrcode.jpg",
      },
      // 项目进展
      projectMilestones: [
        {
          date: '2024年11月18日',
          title: '取件表生成工具项目启动',
          description: '项目正式启动，开始需求分析与技术选型',
          completed: true
        },
        {
          date: '2025年2月',
          title: '取件表生成功能正式上线',
          description: '经过三个月的开发与测试，取件表生成功能正式发布上线',
          completed: true
        },
        {
          date: '2025年9月',
          title: 'AI上色预览功能启动',
          description: '启动AI上色预览功能开发，引入先进的图像处理技术',
          completed: true
        },
        {
          date: '2025年10月27日',
          title: 'AI上色预览功能上线',
          description: 'AI上色预览功能正式上线，为用户提供更智能的上色体验',
          completed: true
        },
        {
          date: '2025年10月2日',
          title: '刻线预览项目启动',
          description: '启动刻线预览项目开发，进一步提升用户体验',
          completed: true
        },
        {
          date: '持续更新中',
          title: '后续项目开发中',
          description: '我们正在不断开发新功能，敬请期待更多精彩内容',
          completed: false
        }
      ],
      isScrolled: false,
      aboutus: {
        "beianhao": "",
        "beianhaoUrl": "",
        "beiandi": "",
        "beiandiUrl": "https://www.mynew-miracle.com/Application/Tpl/App/default/Index/homepage/static/img/03.1bcdb4d.jpg",
        "copyright": "",
        "footColor": "#f45534"
      },
      username: "",
      steps: [
        { title: '登录账号', description: '上传PDF拼装说明书', image: require('@/assets/images/step1.png') },
        { title: '编辑页面', description: '在页面选择页码，提交系统识别', image: require('@/assets/images/step2.png') },
        { title: '下载或获取报告', description: '页面生成完成后，点击获取论文', image: require('@/assets/images/step3.png') }
      ],
      colorsteps: [
        { title: '新建任务', description: '上传模型图', image: require('@/assets/images/colorstep1.png') },
        { title: '编辑颜色', description: '选择画笔与填充修改线稿颜色', image: require('@/assets/images/colorstep2.png') },
        { title: '阅览模拟颜色', description: '阅览模拟颜色', image: require('@/assets/images/colorstep3.png') }
      ],
      activeStep: 0,
      currentSlide: 0,
      slideInterval: null,
      showProfileMenu: false,
      showProfileModal: false,
      showInviteModal: false,
      walletProfile: null,
      profileForm: {
        phone: '',
        name: '',
        dyid: '',
        inviteCode: ''
      }
    }
  },
  computed: {
    displayName() {
      return this.walletProfile?.user?.name || this.username || '个人中心'
    }
  },
  mounted() {
    //this.getDownload(1)
    const token = getStorageSync('token')
    this.username = token ? (getStorageSync('username') || '已登录') : ''
    if (token) {
      this.fetchWalletProfile()
    }
    this.startCarousel()
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('auth-session-changed', this.handleAuthSessionChanged)
  },
  beforeUnmount() {
    this.stopCarousel()
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('auth-session-changed', this.handleAuthSessionChanged)
  },
  beforeDestroy() {
    window.removeEventListener('auth-session-changed', this.handleAuthSessionChanged)
  },
  methods: {
    setBannerPlaybackRate(event) {
      event.currentTarget.playbackRate = 0.3
    },
    handleAuthSessionChanged(event) {
      if (!event.detail?.authenticated) {
        this.username = ''
        this.walletProfile = null
        this.showProfileModal = false
        this.showProfileMenu = false
      }
    },
    handleScroll() {
      this.isScrolled = window.scrollY > 50
    },
    startCarousel() {
      this.carouselTimer = setInterval(() => {
        this.nextSlide()
      }, 5000)
    },
    stopCarousel() {
      if (this.carouselTimer) {
        clearInterval(this.carouselTimer)
      }
    },
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.posterData.length
    },
    prevSlide() {
      this.currentIndex = (this.currentIndex - 1 + this.posterData.length) % this.posterData.length
    },
    goToSlide(index) {
      this.currentIndex = index
    },
    handleStepHover(index) {
      this.activeStep = index
    },
    search(res) {
      this.keyword = res.value
      this.page = 1
      this.getDownload(1)
    },
    bindPickerChange(e) {
      console.log('picker发送选择改变，携带值为', e.target.value)
      this.subjectindex = e.target.value
      this.subject = this.array[e.target.value]
      this.page = 1
      this.getDownload(1)
    },
    change(e) {
      console.log(e)
      this.current = e.current
      this.getDownload(e.current)
    },
    checktopage() {
      if (!this.walletProfile?.user?.invite_code) {
        this.showInviteModal = true
        return
      }
      navigateTo("/paperlist")
    },
    checktopaint() {
      navigateTo("/painter")
    },
    checktoAiColoringList() {
      if (!this.walletProfile?.user?.invite_code) {
        this.showInviteModal = true
        return
      }
      navigateTo("/ai-coloring-list")
    },
    checktoImageGenerator() {
      if (!this.walletProfile?.user?.invite_code) {
        this.showInviteModal = true
        return
      }
      navigateTo("/image-generator")
    },
    goToProfile() {
      this.showInviteModal = false
      this.showProfileModal = true
    },
    tologin() {
      navigateTo("/login")
    },
    async fetchWalletProfile() {
      try {
        const res = await api({ method: 'get', url: '/liner/wallet/profile' })
        if (res.code === 200 || res.code === '200') {
          this.walletProfile = res.data
          this.username = res.data.user?.phone || res.data.user?.name || this.username
          setStorageSync('username', this.username)
          this.profileForm = {
            phone: res.data.user?.phone || '',
            name: res.data.user?.name || '',
            dyid: res.data.user?.dyid || '',
            inviteCode: res.data.user?.invite_code || ''
          }
        }
      } catch (e) {
        console.warn('获取个人中心失败', e)
        this.username = ''
        this.walletProfile = null
      }
    },
    openProfileEditor() {
      this.showProfileMenu = false
      this.showProfileModal = true
    },
    openContactSection() {
      this.showProfileMenu = false
      this.scrollTo(3)
    },
    async saveProfile() {
      try {
        const res = await api({
          method: 'put',
          url: '/liner/profile',
          data: {
            name: this.profileForm.name,
            dyid: this.profileForm.dyid,
            invite_code: this.profileForm.inviteCode
          }
        })
        if (res.code === 200 || res.code === '200') {
          showToast({ title: '保存成功', duration: 1500 })
          this.showProfileModal = false
          await this.fetchWalletProfile()
        } else {
          showToast({ title: res.msg || '保存失败', duration: 2000 })
        }
      } catch (e) {
        showToast({ title: '保存失败', duration: 2000 })
      }
    },
    loadImg(e) {
      console.log("e:----loadImg ", e);
    },
    getConfig() {
      // 在Vue2中，可以通过API获取配置
    },
    getBanner() {
      // 在Vue2中，可以通过API获取轮播图
    },
    relogin() {
      clearAuthSession()
      this.username = ""
      this.walletProfile = null
      this.showProfileMenu = false
      // 不跳转到登录页面，只清空token和username
    },
    getDownload(page) {
      api.formPost('/liner/Gethomepagelist', {
        page: page,
        keyword: this.keyword,
        subject: this.subject,
      })
        .then(res => {
          let data = res.data
          if (data.code == 200) {
            console.log(data.data)
            this.downloadInfo = data.data
            this.total = data.total
          } else {
            showToast("获取失败")
          }
        })
        .catch(_err => {
          showToast("获取失败")
        })
    },
    downloadType(type) {
      switch (type) {
        case 0:
          return 'H5'
          break;
        case 1:
          return 'Android'
          break;
        case 2:
          return 'ios'
          break;
        case 3:
          return '小程序'
          break;
        default:
          break;
      }
    },
    toUrl(item) {
      if (item.open_url) {
        window.open(item.open_url)
      }
    },
    openUrl(url) {
      window.open(url);
    },
    scrollTo(index) {
      this.activeIndex = index
      this.currentId = 'row' + index;
      const element = document.getElementById(this.currentId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }
}
</script>

<style scoped>
.container {
  padding: 0 15px 15px 15px;
  background-color: #f9f9ff;
  border-radius: 0;
  box-shadow: none;
  min-height: 100vh;
}

/* 头部 */
.header {
  padding: 10px clamp(40px, 6vw, 104px);
  border-radius: 0;
  margin-bottom: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: transparent;
  transition: background 0.3s ease;
}

.header.scrolled {
  background: rgba(0, 0, 0, 0.8);
}

.header .title,
.header .tab-item,
.header .profile-trigger,
.header .login-btn,
.header .login-button {
  color: #fff !important;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  position: relative;
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
}

.app-info {
  display: flex;
  align-items: center;
  gap: 15px;
  min-width: 0;
}

.logo {
  width: 50px;
  height: 50px;
  border-radius: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.title {
  font-size: 24px;
  font-weight: bold;
  color: #6a5acd;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tabs {
  display: flex;
  gap: 6px;
  flex-wrap: nowrap;
  justify-content: flex-end;
  align-items: center;
  max-width: 72%;
}

.tab-item {
  position: relative;
  height: 38px;
  padding: 0 12px;
  border-radius: 8px;
  background: transparent;
  color: #44356f;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
  font-weight: 600;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.tab-item::after {
  content: '';
  position: absolute;
  left: 12px;
  right: 12px;
  bottom: 4px;
  height: 2px;
  border-radius: 999px;
  background: #6a5acd;
  transform: scaleX(0);
  transform-origin: center;
  transition: transform 0.22s ease;
}

.tab-item:hover {
  background: rgba(106, 90, 205, 0.1);
  color: #4d3db2;
}

.tab-item:hover::after {
  transform: scaleX(1);
}

.login-button {
  color: #44356f !important;
}

.login-button:hover {
  background: rgba(106, 90, 205, 0.1);
  color: #4d3db2 !important;
}

.login-btn, .logout-btn {
  background: transparent;
  color: #44356f;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
  font-weight: 600;
}

.login-btn:hover, .logout-btn:hover {
  background: rgba(106, 90, 205, 0.1);
  color: #4d3db2;
}

.profile-menu {
  position: relative;
  display: flex;
  align-items: stretch;
  height: 46px;
  padding: 4px 0;
  box-sizing: border-box;
}

.profile-trigger {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 38px;
  max-width: 220px;
  padding: 0 12px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #44356f;
  cursor: pointer;
  font-weight: 600;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.profile-trigger::after {
  content: '';
  position: absolute;
  left: 12px;
  right: 12px;
  bottom: 4px;
  height: 2px;
  border-radius: 999px;
  background: #6a5acd;
  transform: scaleX(0);
  transform-origin: center;
  transition: transform 0.22s ease;
}

.profile-menu:hover .profile-trigger,
.profile-trigger:focus {
  background: rgba(106, 90, 205, 0.1);
  color: #4d3db2;
}

.profile-menu:hover .profile-trigger::after,
.profile-trigger:focus::after {
  transform: scaleX(1);
}

.profile-trigger span:first-child {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.profile-dropdown {
  position: absolute;
  right: 0;
  top: calc(100% - 4px);
  width: 172px;
  padding: 6px;
  background: #fff;
  border: 1px solid #e8e8ff;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  z-index: 20;
  opacity: 0;
  visibility: hidden;
  transform: translateY(6px);
  pointer-events: none;
  transition: opacity 0.3s ease 0.2s, transform 0.3s ease 0.2s, visibility 0.3s ease 0.2s;
}

.profile-menu:hover .profile-dropdown,
.profile-menu:focus-within .profile-dropdown {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
  pointer-events: auto;
  transition-delay: 0s;
}

.profile-dropdown button {
  width: 100%;
  padding: 9px 10px;
  border: none;
  background: transparent;
  color: #333;
  text-align: left;
  cursor: pointer;
  border-radius: 6px;
}

.profile-dropdown button:hover {
  background: #f0f0ff;
  color: #6a5acd;
}

.account-modal {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.account-panel {
  width: min(420px, 94vw);
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.18);
  padding: 18px;
}

.wallet-panel {
  width: min(620px, 94vw);
}

.account-panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.account-panel-header h3 {
  margin: 0;
  color: #333;
}

.account-panel-header button {
  width: 30px;
  height: 30px;
  border: none;
  border-radius: 6px;
  background: #f0f0ff;
  cursor: pointer;
}

.account-form {
  display: grid;
  gap: 8px;
}

.account-form label {
  font-size: 13px;
  color: #666;
}

.account-form input,
.recharge-row input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #e8e8ff;
  border-radius: 8px;
  outline: none;
}

.account-form input.input-disabled {
  background-color: #f5f5f5;
  color: #999;
  cursor: not-allowed;
}

.account-actions,
.recharge-row {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 16px;
}

.account-actions button,
.recharge-row button {
  padding: 9px 16px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.account-actions .primary,
.recharge-row .primary {
  background: #6a5acd;
  color: #fff;
}

.wallet-summary {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px;
  border-radius: 10px;
  background: #f8f7ff;
  color: #333;
}

.wallet-summary strong {
  color: #6a5acd;
  font-size: 22px;
}

.order-list {
  margin-top: 16px;
  max-height: 320px;
  overflow-y: auto;
  border-top: 1px solid #eee;
}

.order-item {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid #eee;
  color: #333;
}

.order-item div:first-child {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.order-item span {
  color: #888;
  font-size: 12px;
}

.income {
  color: #18a058;
  font-weight: 700;
}

.expense {
  color: #d03050;
  font-weight: 700;
}

.empty-orders {
  padding: 24px;
  text-align: center;
  color: #999;
}

.scroll-view {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding-top: 80px;
}

.section {
  margin-bottom: 30px;
  padding: 20px;
  background-color: white;
  border-radius: 15px;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.05);
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #e8e8ff;
}

.section-title {
  font-size: 1.5em;
  font-weight: bold;
  color: #6a5acd;
  padding: 5px 15px;
  background-color: #f0f0ff;
  border-radius: 20px;
  display: inline-block;
}

.section-divider {
  width: 100px;
  height: 3px;
  background: linear-gradient(to right, #6a5acd, #ff9eb5);
  border-radius: 3px;
}

/* 轮播 */
.carousel-wrapper {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  border-radius: 0;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.carousel-wrapper-full {
  position: relative;
  width: 100% !important;
  height: 100vh;
  overflow: hidden;
  margin-top: 0 !important;
}

.carousel {
  width: 100%;
  height: 100%;
  position: relative;
}

.carousel-item {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 0.8s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
}

.carousel-item.active {
  opacity: 1;
}

.carousel-video, .carousel-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.carousel-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0.3) 50%, rgba(0,0,0,0.6) 100%);
  pointer-events: none;
}

.carousel-content {
  position: relative;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 20px 40px;
  width: min(920px, calc(100% - 32px));
}

.banner-nav {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  width: min(540px, 100%);
  margin-top: 4px;
}

.banner-nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-width: 0;
  min-height: 72px;
  padding: 11px 14px;
  background: rgba(12, 18, 32, 0.5);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  font: inherit;
  font-size: 14px;
  font-weight: 600;
}

.banner-nav-item:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 200, 255, 0.3);
}

.banner-nav-icon {
  font-size: 22px;
}

.profile-icon {
  margin-right: 6px;
  font-size: 16px;
}

.carousel-title {
  font-size: 4em;
  font-weight: bold;
  margin-bottom: 20px;
  color: #fff;
  text-shadow: 0 0 20px rgba(255, 255, 255, 0.5);
  letter-spacing: 8px;
  transform: scaleY(1);
}

.banner-icon {
  width: 150px;
  height: auto;
  margin-bottom: 20px;
}

.banner-title-image {
  width: 400px;
  height: auto;
  margin-bottom: 20px;
  position: relative;
  border-radius: 12px;
  backdrop-filter: blur(1px);
  -webkit-backdrop-filter: blur(1px);
  background: linear-gradient(135deg,hsla(0,0%,20%,.1),hsla(0,0%,30%,.05) 20%,hsla(0,0%,20%,.1));
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 
    0 8px 32px rgba(0, 0, 0, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.2),
    0 0 60px rgba(0, 200, 255, 0.3),
    0 0 100px rgba(255, 0, 200, 0.2);
  animation: cyberpunkGlow 3s ease-in-out infinite alternate;
}

@keyframes cyberpunkGlow {
  0% {
    box-shadow: 
      0 8px 32px rgba(0, 0, 0, 0.3),
      inset 0 1px 0 rgba(255, 255, 255, 0.2),
      0 0 60px rgba(0, 200, 255, 0.3),
      0 0 100px rgba(255, 0, 200, 0.2);
  }
  100% {
    box-shadow: 
      0 8px 32px rgba(0, 0, 0, 0.3),
      inset 0 1px 0 rgba(255, 255, 255, 0.2),
      0 0 80px rgba(0, 200, 255, 0.5),
      0 0 120px rgba(255, 0, 200, 0.4);
  }
}

.banner-title-image::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 50%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  animation: lightSweep 4s linear infinite;
  pointer-events: none;
}

@keyframes lightSweep {
  0% {
    left: -100%;
  }
  100% {
    left: 200%;
  }
}

.carousel-text {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.carousel-title::after {
  content: attr(data-text);
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  color: rgba(255, 255, 255, 0.3);
  text-shadow: 0 -2px 10px rgba(255, 255, 255, 0.3);
  transform: scaleY(-1);
  background: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.3));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  pointer-events: none;
}

.carousel-subtitle {
  font-size: 1.8em;
  color: #fff;
  text-shadow: 0 0 15px rgba(255, 255, 255, 0.5);
  letter-spacing: 2px;
}

/* 轮播指示器 */
.carousel-indicators {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  z-index: 20;
}

.indicator {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: all 0.3s;
}

.indicator.active {
  background: #fff;
  transform: scale(1.2);
}

/* 轮播控制按钮 */
.carousel-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  font-size: 24px;
  cursor: pointer;
  z-index: 20;
  transition: all 0.3s;
  backdrop-filter: blur(5px);
}

.carousel-btn:hover {
  background: rgba(255, 255, 255, 0.4);
}

.carousel-btn.prev {
  left: 20px;
}

.carousel-btn.next {
  right: 20px;
}

/* 步骤指南 */
.ds-steps {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
}

.ds-step {
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.3s;
  background-color: #f9f9ff;
}

.ds-step:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 15px rgba(106, 90, 205, 0.2);
}

.ds-step-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  background-color: #e8e8ff;
}

.ds-step-badge {
  font-size: 0.9rem;
  font-weight: 600;
  color: #6a5acd;
  background-color: #f0f0ff;
  padding: 5px 10px;
  border-radius: 10px;
}

.ds-step-decorator {
  width: 12px;
  height: 12px;
  background-color: #ff9eb5;
  border-radius: 50%;
}

.ds-step-image {
  width: 100%;
  height: 180px;
  object-fit: cover;
  margin-bottom: -5px;
}

.ds-step-content {
  padding: 15px;
}

.ds-step-description {
  font-size: 0.95rem;
  line-height: 1.6;
  color: #555;
}

/* 联系我们 */
.contact-section {
  text-align: center;
}

.contact-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.contact-slogan {
  font-size: 1.3em;
  font-weight: bold;
  color: #6a5acd;
  margin-bottom: 10px;
}

.dy-info {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}

.dy-name {
  font-size: 1.1em;
  color: #555;
  font-weight: 500;
}

.dy-qrcode {
  margin: 15px 0;
}

.qrcode-image {
  width: 200px;
  height: 240px;
  border-radius: 15px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s;
}

.qrcode-image:hover {
  transform: scale(1.05);
}

/* AI生图模块 */
.image-generator-section {
  background: linear-gradient(135deg, #f9f9ff 0%, #f0f0ff 100%);
}

.generator-content {
  text-align: center;
}

.generator-features {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.feature-card {
  background-color: white;
  border-radius: 15px;
  padding: 25px;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.feature-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(106, 90, 205, 0.15);
}

.feature-icon {
  font-size: 40px;
  margin-bottom: 15px;
}

.feature-card h4 {
  margin: 0 0 10px 0;
  color: #6a5acd;
  font-size: 16px;
}

.feature-card p {
  margin: 0;
  color: #666;
  font-size: 14px;
  line-height: 1.6;
}

.generator-action {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.generator-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 15px 40px;
  background: linear-gradient(135deg, #6a5acd 0%, #9370db 100%);
  color: white;
  border: none;
  border-radius: 30px;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(106, 90, 205, 0.3);
}

.generator-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(106, 90, 205, 0.4);
}

.generator-btn .btn-icon {
  font-size: 24px;
}

.generator-tip {
  margin: 0;
  color: #999;
  font-size: 14px;
}

/* 项目进展 */
.project-section {
  margin-top: 40px;
}

.project-timeline {
  position: relative;
  max-width: 800px;
  margin: 0 auto;
  padding: 20px 0;
}

.project-timeline::before {
  content: '';
  position: absolute;
  top: 0;
  left: 20px;
  height: 100%;
  width: 4px;
  background: linear-gradient(to bottom, #e8e8ff, #6a5acd);
  border-radius: 2px;
}

.milestone {
  position: relative;
  padding-left: 50px;
  margin-bottom: 30px;
  animation: fadeInUp 0.6s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.milestone-content {
  background-color: #f9f9ff;
  border-radius: 15px;
  padding: 15px 20px;
  box-shadow: 0 3px 10px rgba(106, 90, 205, 0.1);
  transition: all 0.3s ease;
}

.milestone-content:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 15px rgba(106, 90, 205, 0.2);
}

.milestone-date {
  font-weight: 600;
  color: #6a5acd;
  font-size: 0.85rem;
  margin-bottom: 10px;
  text-align: left;
}

.milestone-title {
  margin: 0 0 8px 0;
  color: #333;
  font-size: 1.1rem;
}

.milestone-description {
  margin: 0;
  color: #666;
  font-size: 0.95rem;
  line-height: 1.5;
}

.milestone-dot {
  position: absolute;
  left: 16px;
  top: 18px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #e8e8ff;
  border: 3px solid #6a5acd;
  z-index: 1;
}

.milestone-dot.active {
  background-color: #6a5acd;
  box-shadow: 0 0 0 4px rgba(106, 90, 205, 0.2);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .container {
    padding: 10px;
    margin: 0;
    border-radius: 0;
  }

  .header {
    padding: 8px 16px;
    border-radius: 0;
  }

  .logo {
    width: 40px;
    height: 40px;
  }

  .header-content {
    flex-direction: row;
    align-items: center;
    text-align: left;
    gap: 10px;
  }

  .app-info {
    justify-content: flex-start;
    flex: 1;
    margin-bottom: 0;
    gap: 8px;
  }

  .title {
    font-size: 16px;
    max-width: calc(100vw - 190px);
  }

  .tabs {
    display: flex;
    gap: 4px;
    max-width: none;
    width: auto;
    margin-top: 0;
  }

  .tab-item {
    width: auto;
    min-height: 42px;
    padding: 9px 10px;
    border-radius: 10px;
    font-size: 14px;
  }

  .profile-menu {
    width: auto;
    padding-bottom: 0;
  }

  .profile-trigger {
    width: auto;
    max-width: 142px;
    min-height: 42px;
    border-radius: 10px;
  }

  .profile-dropdown {
    right: 0;
    left: auto;
    top: calc(100% - 4px);
    width: 172px;
  }

  .profile-dropdown button {
    padding: 11px 12px;
    text-align: center;
  }

  .carousel-item {
    flex-direction: column;
  }

  .carousel-content {
    width: calc(100% - 24px);
    gap: 12px;
    padding: 72px 12px 20px;
  }

  .banner-icon {
    width: 96px;
    margin-bottom: 6px;
  }

  .banner-title-image {
    width: min(300px, 88vw);
    margin-bottom: 8px;
  }

  .banner-nav {
    gap: 6px;
    width: 100%;
  }

  .banner-nav-item {
    min-height: 64px;
    padding: 8px 4px;
    font-size: 12px;
  }

  .banner-nav-icon {
    font-size: 18px;
  }

  .carousel-text {
    padding-right: 0;
    margin-bottom: 15px;
  }

  .carousel-image {
    width: 100%;
    max-width: 300px;
  }

  .ds-steps {
    grid-template-columns: 1fr;
  }

  .contact-slogan {
    font-size: 1.1em;
  }

  .dy-name {
    font-size: 1em;
  }

  .qrcode-image {
    width: 180px;
    height: 180px;
  }

  .project-timeline {
    padding-left: 20px;
  }

  .project-timeline::before {
    left: 15px;
  }

  .milestone {
    padding-left: 40px;
  }

  .milestone-date {
    font-size: 0.8rem;
    margin-bottom: 8px;
  }

  .milestone-dot {
    left: 11px;
    top: 15px;
  }

  .milestone-title {
    font-size: 1rem;
  }

  .milestone-description {
    font-size: 0.9rem;
  }
}

/* 页脚 */
.footer {
  text-align: center;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  padding: 20px 10px;
  background: rgba(10, 14, 39, 0.95);
  border-top: 1px solid rgba(0, 255, 255, 0.1);
}

.footer p {
  margin: 5px 0;
}

/* 友情链接 */
.friend-link {
  position: fixed;
  right: 30px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 100;
  display: block;
}

.friend-link-img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  transition: transform 0.3s, box-shadow 0.3s;
}

.friend-link-img:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);
}

/* 邀请码提示弹窗 */
.invite-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.invite-modal {
  background: #fff;
  border-radius: 16px;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

.invite-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
}

.invite-modal-header h3 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.invite-modal-header .close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #999;
  padding: 0;
  line-height: 1;
}

.invite-modal-header .close-btn:hover {
  color: #333;
}

.invite-modal-body {
  padding: 20px;
}

.invite-modal-body p {
  margin: 0 0 15px 0;
  color: #666;
  font-size: 14px;
  line-height: 1.6;
}

.contact-info {
  background: #f9f9ff;
  border-radius: 12px;
  padding: 15px;
  margin-bottom: 15px;
}

.contact-item {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.contact-label {
  font-weight: bold;
  color: #6a5acd;
}

.qrcode-container {
  text-align: center;
  margin-top: 15px;
}

.modal-qrcode {
  width: 150px;
  height: 150px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.qrcode-tip {
  margin-top: 8px !important;
  color: #999;
  font-size: 12px !important;
}

.invite-modal-actions {
  display: flex;
  gap: 10px;
}

.invite-modal-actions button {
  flex: 1;
  padding: 12px;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  border: none;
  transition: all 0.3s;
}

.invite-modal-actions .primary-btn {
  background: linear-gradient(135deg, #6a5acd, #8b5cf6);
  color: #fff;
}

.invite-modal-actions .primary-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(106, 90, 205, 0.4);
}

.invite-modal-actions .secondary-btn {
  background: #f0f0f0;
  color: #666;
}

.invite-modal-actions .secondary-btn:hover {
  background: #e0e0e0;
}
</style>
